<template>
  <div>
    <div v-if="open">
      <div class="columns">
        <div class="column">
          <b-field>
            <b-input v-model="search" icon="magnify" placeholder="Cari..." @keyup.enter.native="clickHandler"></b-input>
          </b-field>
        </div>

        <div class="column is-narrow" v-if="is_academic">
          <div class="field cari-post">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="period">
                  <option value="">Pilih Periode</option>
                  <option v-for="(period, key) in periods" :key="key" :value="period.value">{{ period.text }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-narrow">
          <div class="buttons" style="margin-bottom: 0;">
            <button type="button" @click.prevent="clickHandler" class="button is-primary" :disabled="loading" :class="{'is-loading': loading}" style="margin-bottom: 0;">
              <span class="icon"><i class="fas fa-filter"></i></span>
              <span>Terapkan</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    dataProvider: {
      type: Object,
      required: true,
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    is_academic: {
      type: Boolean,
      default: true
    },
    toggle_key: {
      type: String,
      default: 'open_class_filter'
    }
  },

  mounted() {
    this.period = this.auth && this.auth.activeAccount && this.activePeriod ? this.activePeriod.value : "";
  },

  computed: {
    ...mapState({
      periods: (state) => state.universities.periods,
      activePeriod: (state) => state.universities.activePeriod,
    }),
    open: {
      get() {
        return this.$parent[this.toggle_key]
      },
      set(val) {
        this.$parent[this.toggle_key] = val
      }
    },
    search: {
      get() {
        const vm = this;
        const search = collect(this.dataProvider.criterion).where('criteria', vm.search_criteria).first();

        return !this.isEmpty(search) ? search.value : '';
      },
      set(val) {
        const vm = this;
        this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
          if (c.criteria == vm.search_criteria) {
            c['value'] = val;
          }

          return c;
        }).toArray();
      }
    },
    sort: {
      get() {
        const vm = this;
        const sort = collect(this.dataProvider.sort).first();
        let option = null;

        if (!vm.isEmpty(sort)) {
          option = collect(this.sort_options).where('criteria', '==', sort.criteria).where('order', '==', sort.order).first();
        }

        return !this.isEmpty(option) ? option.value : '';
      },
      set(val) {
        const vm = this;
        let option = collect(this.sort_options).where('value', '==', val).first();

        if (!this.isEmpty(option)) {
          this.dataProvider['sort'] = [{
            criteria: option.criteria,
            order: option.order,
            no_table: true
          }]
        }
      }
    },
  },

  data() {
    return {
      period: "",
      search_criteria: 'keyword',
      period_criteria: 'periode',
      sort_criteria: 'name',
      sort_options: [
        { criteria: 'name', order: 'asc', value: 'name__asc', text: 'A - Z' },
        { criteria: 'name', order: 'desc', value: 'name__desc', text: 'Z - A' },
        { criteria: 'created_at', order: 'desc', value: 'created_at__desc', text: 'Terbaru' },
        { criteria: 'created_at', order: 'asc', value: 'created_at__asc', text: 'Terlama' },
      ]
    }
  },

  watch: {
    period(val) {
      this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
        if (c.criteria == this.period_criteria) {
          c['value'] = val;
        }

        return c;
      }).toArray();
    }
  }
}
</script>
